import en from './en.json';
import tr from './tr.json';
import ar from './ar.json';

export type LocaleKey = 'tr' | 'en' | 'ar';

export const translations: Record<LocaleKey, Record<string, string>> = {
  tr,
  en,
  ar,
};

export const availableLocales: Array<{ key: LocaleKey; labelKey: string }> = [
  { key: 'tr', labelKey: 'language.turkish' },
  { key: 'en', labelKey: 'language.english' },
];
